import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useSelector } from "react-redux";
import Typography from "../../common-components/Typography";
import { font } from "../../constants/font";
import content from "../../constants/content";
import vmTheme from "../../constants/theme";
import { STATIC_PATH } from "../../constants/config";

export const WatermarkBar = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border-radius: $0 0 12px 12px;
  border-radius: ${(props) => props.$isVertical ? "0 0 12px 12px" : "12px"};
  border-right: ${(props) => props.$isVertical ? "1px solid #FFC069" : "none"};
  border-bottom: ${(props) => props.$isVertical ? "1px solid #FFC069" : "none"};
  border-left: ${(props) => props.$isVertical ? "1px solid #FFC069" : "none"};
  border-top: ${(props) => props.$isVertical ? "none" : "none"};
  margin-top: ${(props) => props.$isVertical ? "0" : "6px"};
  background: #FFF;
  cursor: pointer;
  box-sizing: border-box;

  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  &:hover {
    background: ${props => props.$isVertical ? "#FFF5EF" : "#EDEEF2"};
  }
`;

const ShortsCardWatermark = ({ onClick, isVertical }) => {
  const theme = useSelector((state) => state.app.get("theme"));

  return (
    <WatermarkBar type="button" onClick={onClick} $isVertical={isVertical}>
      <img src={`${STATIC_PATH}upgrade.svg`} alt="" />
      <Typography
        content={content.REMOVE_WATERMARK}
        font={font.boldBase}
        color={vmTheme[theme].panelPrimaryColor}
        enableTrim={false}
        display="block"
        padding="0"
        cursor="pointer"
      />
    </WatermarkBar>
  );
};

ShortsCardWatermark.propTypes = {
  onClick: PropTypes.func,
  isVertical: PropTypes.bool,
};

export default ShortsCardWatermark;
